import validateIsBoolean from '../core/validators/validateIsBoolean';
import validateIsNull from '../core/validators/validateIsNull';
import validateIsNumber from '../core/validators/validateIsNumber';
import validateIsString from '../core/validators/validateIsString';

type Validator =
  | typeof validateIsBoolean
  | typeof validateIsNull
  | typeof validateIsNumber
  | typeof validateIsString;

const literalValidatorsByType: {
  [literalType: string]: Validator;
} = {
  boolean: validateIsBoolean,
  null: validateIsNull,
  number: validateIsNumber,
  string: validateIsString,
};

export default literalValidatorsByType;
